<template>
  <div class="corner-tag">
    <p>
      {{ tagName }}
    </p>
  </div>
</template>

<script>
export default {
  name: 'BtnCornerTag',
  props: {
    tagName: {
      type: String
    }
  },
  methods: {}
}
</script>
<style lang="less" scoped>
@import '~uikit';
.corner-tag {
  pointer-events: none;
  position: absolute;
  left: 0;
  top: 0;
  width: 100px;
  height: 100px;
  overflow: hidden;
  transform-origin: 0 0;
  transform: scale(0.5);
  p {
    position: absolute;
    left: -32px;
    top: 5px;
    font-size: 18px;
    transform: rotate(-45deg);
    background-color: #78e6fa;
    color: #333;
    width: 100px;
    text-align: center;
  }
}
</style>
